module.exports = __webpack_public_path__ + "img/logo_white.69f0fe49.svg";